import { Model, attr } from '@elatonsev/js-models';

export default class ServiceModel extends Model {
  name = attr('string');
  description = attr('string');
  duration = attr('number');
  min_price = attr('number');
  max_price = attr('number');
}